'use strict'

const Big = require('big.js').default
const { findByChainId } = require('chain-list')

/**
 * Formats a big number from a unit
 *
 * @param {number} number The number to be formated.
 * @param {number} decimals The decimals used to format the number.
 * @returns {string} Returns the new format
 */
const fromUnit = (number, decimals = 18) =>
  Big(`${Big(number).toFixed()}e-${decimals}`).toFixed()

/**
 * Formats a big number to a unit
 *
 * @param {number} number The number to be formated.
 * @param {number} decimals The decimals used to format the number.
 * @returns {string} Returns the new format
 */
const toUnit = (number, decimals = 18) =>
  Big(`${Big(number).toFixed()}e+${decimals}`).toFixed(0)

const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

const handleForkedChainId = id =>
  // Bypass ganache-core and hardhat chainId issue by changing 31337/1337 back to mainnet.
  // See: https://github.com/trufflesuite/ganache-core/issues/451
  [1337, 31337].includes(id) ? 1 : id

const createIsNativeToken = function (chainId) {
  const { nativeTokenSymbol } = findByChainId(chainId)
  return symbol => symbol === nativeTokenSymbol
}

const getMinimalRenderableValue = decimals =>
  (decimals > 0 ? Big(`0.${'0'.repeat(decimals - 1)}1`) : '1').toString()

const isLessThanMinimalRenderableValue = (value, decimals) =>
  Big(value).lt(getMinimalRenderableValue(decimals)) && !Big(value).eq('0')

module.exports = {
  createIsNativeToken,
  fromUnit,
  getMinimalRenderableValue,
  handleForkedChainId,
  isLessThanMinimalRenderableValue,
  toUnit,
  ZERO_ADDRESS
}
